export default "__VITE_ASSET__453631af__"